// TUTORIAL-END-PROMPT: Full-screen signup modal shown after the 5-slide tutorial
// concept finishes. Two CTAs — primary "Sign up free" + secondary "Sign in" link
// for returning users on a new device. Close (X) returns to splash.

import { getFontFamily } from "../constants/colors";

export function TutorialEndPrompt({ lang = "en", onSignUp, onSignIn, onClose }) {
  const ff = getFontFamily(lang);
  const isHi = lang === "hi";

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(10,24,32,0.6)",
      backdropFilter: "blur(6px)", WebkitBackdropFilter: "blur(6px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 16, fontFamily: ff,
      animation: "fadeIn 0.25s ease",
    }}>
      <style>{`
        @keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
        @keyframes pop { 0% { transform:translateY(20px) scale(0.96); opacity:0; } 100% { transform:translateY(0) scale(1); opacity:1; } }
      `}</style>

      <div style={{
        maxWidth: 380, width: "100%",
        background: "white", borderRadius: 24,
        padding: "32px 24px",
        boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        position: "relative",
        animation: "pop 0.3s cubic-bezier(0.2, 0.8, 0.3, 1)",
      }}>
        {/* Close (X) — returns to splash */}
        <button
          onClick={onClose}
          aria-label={isHi ? "बंद करें" : "Close"}
          style={{
            position: "absolute", top: 12, right: 12,
            width: 32, height: 32, borderRadius: "50%",
            background: "transparent", border: "none",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "#6A808C",
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        {/* Celebration emoji + title */}
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{ fontSize: 44, marginBottom: 8, lineHeight: 1 }}>🎉</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#1E2A4A", letterSpacing: "-0.02em" }}>
            {isHi ? "बढ़िया!" : "Nice work!"}
          </div>
          <div style={{ fontSize: 13, color: "#5C6B82", marginTop: 8, lineHeight: 1.5 }}>
            {isHi
              ? "आपने Samajh का एक concept पूरा किया। साइन अप करके और सीखें:"
              : "You just finished a Samajh concept. Sign up to:"}
          </div>
        </div>

        {/* Benefits list */}
        <div style={{
          background: "#F5F9FB", borderRadius: 14, padding: "16px 18px",
          border: "1px solid #E6EEF5", marginBottom: 24,
        }}>
          {[
            isHi ? "सभी chapters में अपनी progress track करें" : "Track your learning across chapters",
            isHi ? "Points कमाएँ और Mastery unlock करें" : "Earn points and unlock Mastery",
            isHi ? "AI tutor से personalized मदद पाएं" : "Get personalized Socratic help",
            isHi ? "बीटा के दौरान मुफ्त" : "Free for now during beta",
          ].map((item, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "6px 0",
            }}>
              <div style={{
                width: 20, height: 20, borderRadius: "50%", background: "#E1F5EE",
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
              }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#1A7A52" strokeWidth="3" strokeLinecap="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <span style={{ fontSize: 13, color: "#1E2A4A", fontWeight: 500, lineHeight: 1.4 }}>{item}</span>
            </div>
          ))}
        </div>

        {/* Primary CTA: Sign up free */}
        <button
          onClick={onSignUp}
          style={{
            width: "100%", padding: "15px",
            background: "#1A7A52", color: "white",
            border: "none", borderRadius: 14,
            fontSize: 16, fontWeight: 700, cursor: "pointer",
            fontFamily: ff, letterSpacing: "-0.01em",
            boxShadow: "0 4px 14px rgba(26,122,82,0.30)",
          }}
        >
          {isHi ? "मुफ्त साइन अप करें →" : "Sign up free →"}
        </button>

        {/* Secondary: Sign in link */}
        <div style={{ textAlign: "center", marginTop: 14, fontSize: 13, color: "#5C6B82" }}>
          {isHi ? "पहले से खाता है? " : "Already have an account? "}
          <span onClick={onSignIn} style={{ color: "#1A7A52", fontWeight: 600, cursor: "pointer" }}>
            {isHi ? "लॉगिन करें" : "Sign in"}
          </span>
        </div>
      </div>
    </div>
  );
}
